import { lazy } from "react";

export { SURVEY_LIST_PATH } from "./survey-list-path";
export const SurveyListPage = lazy(() => import("./survey-list"));
